
import Japan from "../assets/japan-landmark.jpg" ;
import Hongkong from "../assets/hongkong.png" ;
import Singapore from "../assets/singapore.png" ;
import China from "../assets/china.webp";
import Europe from "../assets/Europe.jpg";
import Bahama from "../assets/bahama.jpg";
import Caribbean from "../assets/caribbean_header.webp";
import Goa from "../assets/Goa_india.webp";

const destination = [
    {
        img:Japan,
        name:"Japan" ,
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=124&sortcolumn=price&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&destinations=124&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=124&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&destinations=124&sortcolumn=price&sortorder=asc"
    }
    },

    {
        img:Hongkong,
        name:"Hong Kong",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=19,130&departureports=HKG&sortcolumn=price&sortorder=asc"
      links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&destinations=19,130&departureports=HKG&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=19,130&departureports=HKG&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&destinations=19,130&departureports=HKG&sortcolumn=price&sortorder=asc"
    }
    },

    {
        img:Singapore,
        name:"Singapore",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=19,45,47,130,44&departureports=SIN&sortcolumn=price&sortorder=asc"
     links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&destinations=19,45,47,130,44&departureports=SIN&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=19,45,47,130,44&departureports=SIN&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&destinations=19,45,47,130,44&departureports=SIN&sortcolumn=price&sortorder=asc"
    }
    },

    {
        img:China,
        name:"China",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=19,130&departureports=BJS,SHA,BAOS,TSN&sortcolumn=price&sortorder=asc"
      links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&destinations=19,130&departureports=BJS,SHA,BAOS,TSN&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=19,130&departureports=BJS,SHA,BAOS,TSN&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&destinations=19,130&departureports=BJS,SHA,BAOS,TSN&sortcolumn=price&sortorder=asc"
    }
    },

    {
        img:Europe,
        name:"Europe",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=142,68,38,16,15,75,39,188,40,41,18&rivers=77,82,85,80,96,179,81,95,78,79,88,76,84,102,83&sortcolumn=price&sortorder=asc"
     links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&destinations=142,68,38,16,15,75,39,188,40,41,18&rivers=77,82,85,80,96,179,81,95,78,79,88,76,84,102,83&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=142,68,38,16,15,75,39,188,40,41,18&rivers=77,82,85,80,96,179,81,95,78,79,88,76,84,102,83&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&destinations=142,68,38,16,15,75,39,188,40,41,18&rivers=77,82,85,80,96,179,81,95,78,79,88,76,84,102,83&sortcolumn=price&sortorder=asc"
    }
    },

    {
        img:Bahama,
        name:"Bahamas",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=7&sortcolumn=price&sortorder=asc"
      links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&destinations=7&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&destinations=7&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&destinations=7&sortcolumn=price&sortorder=asc"
    }
    },

    {
        img:Caribbean,
        name:"Caribbean",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc"
      links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc"
    }
    }

    ,

    {
        img:Goa,
        name:"India",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc"
      links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&Destinations=73,63&destinationtype=All&cruiseline=9190&sortColumn=cruiselinePriority&sortOrder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&Destinations=73,63&destinationtype=All&cruiseline=9190&sortColumn=cruiselinePriority&sortOrder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&Destinations=73,63&destinationtype=All&cruiseline=9190&sortColumn=cruiselinePriority&sortOrder=asc"
    }
    }

]

export default destination ;